import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "WorkStream Pro - Maintenance management software (CMMS)",
  description = "WorkStream Pro is maintenance software for work orders, preventive maintenance, inventory, and locations. Free is $0. Pro is $29 per month. Enterprise is contact us.",
  keywords = "maintenance management software, CMMS, work order management, preventive maintenance, facility management, inventory tracking",
  canonical = "https://workstreampro.us/",
  ogImage = "https://workstreampro.us/og-image.png",
  type = "website"
}) => {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "WorkStream Pro",
    "url": "https://workstreampro.us",
    "logo": "https://workstreampro.us/logo512.png",
    "description": description,
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "email": "bc2801@hotmail.com"
    }
  };

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "WorkStream Pro",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web, iOS, Android",
    "offers": [
      {
        "@type": "Offer",
        "name": "Free",
        "price": "0",
        "priceCurrency": "USD"
      },
      {
        "@type": "Offer",
        "name": "Pro",
        "price": "29",
        "priceCurrency": "USD",
        "description": "$29 per month for the company"
      }
    ],
    "description": "Maintenance management software (CMMS) for work orders, preventive maintenance, inventory, and locations.",
    "screenshot": "https://workstreampro.us/screenshot.png",
    "softwareVersion": "1.0",
    "datePublished": "2024-01-01",
    "author": {
      "@type": "Organization",
      "name": "WorkStream Pro"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How long does it take to set up WorkStream Pro?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Create a company, then add locations, people, and work orders in the workspace. Email bc2801@hotmail.com if you want help."
        }
      },
      {
        "@type": "Question",
        "name": "Can I try WorkStream Pro before committing?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A new company starts a 14-day trial with up to 5 users and 50 work orders. No credit card is required. The trial is not the Pro plan."
        }
      },
      {
        "@type": "Question",
        "name": "Is my data secure with WorkStream Pro?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Each company's records are stored separately. The privacy, terms, and cookie pages are drafts pending legal review."
        }
      },
      {
        "@type": "Question",
        "name": "Can I customize WorkStream Pro for my business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Pro and Enterprise plans include custom fields, workflows, and branding options to match your business needs."
        }
      }
    ]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://workstreampro.us"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Features",
        "item": "https://workstreampro.us/landing#features"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Pricing",
        "item": "https://workstreampro.us/landing#pricing"
      }
    ]
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter Card */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(softwareSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
